(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_announcement"] && !Shopify.designMode) return;
  try {
    (function () {
    function initCountdowns() {
      document.querySelectorAll('.announcement-countdown[data-end]').forEach(function (el) {
        if (el.dataset.initialized) return;
        el.dataset.initialized = 'true';

        var endDate = new Date(el.dataset.end + 'T23:59:59+02:00');

        function tick() {
          var diff = endDate - Date.now();
          if (diff <= 0) {
            el.textContent = 'Offer has ended';
            el.classList.add('announcement-countdown--expired');
            return;
          }
          var d = Math.floor(diff / 86400000);
          var h = Math.floor((diff % 86400000) / 3600000);
          var m = Math.floor((diff % 3600000) / 60000);
          el.textContent =
            'Offer ends in ' + d + 'd ' + h + 'h ' + m + 'm';
          setTimeout(tick, 30000);
        }
        tick();
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initCountdowns);
    } else {
      initCountdowns();
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
